"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
externalTriggerInterface.addToCartFinally = () => {
    const mainProductElm = document.querySelector('#main_product_section');
    const mainProductElmSID = mainProductElm.dataset.sid;
    const query = [{
            sectionID: mainProductElmSID,
            targetIdentifier: '#price_shippingPolicy_wrapper',
            sectionidentifier: '#price_shippingPolicy_wrapper',
        }];
    const returnExtraItemId = () => {
        const productMeta = document.getElementById('main_product_section');
        const variantIds = productMeta.dataset.extraitemsid;
        if (!variantIds)
            return undefined;
        return variantIds.split(',').map((el) => {
            return Number(el);
        });
    };
    const addExtraItemHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        const variantIds = returnExtraItemId();
        if (!variantIds)
            return;
        try {
            setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                const itemsToAdd = variantIds.map((el) => {
                    return {
                        variantId: el,
                        quantity: 1
                    };
                });
                const res = yield moobiQueries.addCartItem(itemsToAdd);
                if (!(res === null || res === void 0 ? void 0 : res.items))
                    throw new Error('No returned item from AJAX add to cart API.');
                const modifiedItems = res.items.map((el) => {
                    return Object.assign(Object.assign({}, el), { image_X100: MoobiUtilities.resizeImageSrc(el.featured_image.url, 100) });
                });
                CartNotificationModifier.closeNotification();
                new CartNotificationModifier(modifiedItems);
            }), 500);
        }
        catch (error) {
            console.log(error);
        }
    });
    MoobiUtilities.renderSection(query);
    addExtraItemHandler();
};
